import { gsap } from 'gsap';

export default {
  props: {
    durationEnter: Number,
    durationLeave: Number,
  },
  template: '<transition :css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave" @after-leave="afterLeave"><slot></slot></transition>',
  methods: {
    beforeEnter(el) {
      el.style.height = '0px';
      el.style.overflow = 'hidden';
    },
    enter(el, done) {
      gsap.to(el, this.durationEnter, {
        height: el.children[0].offsetHeight,
        onComplete() {
          done();
          el.removeAttribute('style');
        },
      });
    },
    leave(el, done) {
      el.style.overflow = 'hidden';
      gsap.to(el, this.durationLeave, {
        height: 0,
        onComplete() {
          done();
        },
      });
    },
    afterLeave(el) {
      el.style.overflow = null;
    },
  },
};



// WEBPACK FOOTER //
// ./core/animation/height/animation-height.js